import { Dialog } from "../../components/dialogs/Dialog";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useLocale } from "../../providers/LocaleProvider";

interface ImportJobCopyDialogProps {
  open: boolean;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
  theme?: any;
  label?: "Import" | "Import and Edit";
  onImportAndEdit?: () => void;
}

const ImportJobCopyDialog: React.FC<ImportJobCopyDialogProps> = ({
  open,
  loading,
  onConfirm,
  onClose,
  theme
}) => {
  const { translate } = useLocale();

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importJobAsCopy")}
      actions={[
        {
          label: translate("settings.importAsCopy"),
          primary: true,
          variant: "filled",
          disabled: loading,
          onClick: onConfirm,
          isLoading: loading
        },
        {
          label: translate("common.cancel"),
          onClick: onClose
        }
      ]}
    >
      <Box>
        <Typography>{translate("settings.jobAlreadyExists")}</Typography>
      </Box>
    </Dialog>
  );
};

export default ImportJobCopyDialog;
